import React, { useContext, useEffect, useState } from "react";
import "../../../assets/css/user/marqueebanner/marqueebanner.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const MarqueeBanner = ({ speed = 28 }) => {
  const { baseUrl } = useContext(AppContext);
  const [items, setItems] = useState([]);

  const fetchAllBanners = () => {
    axios
      .get(`${baseUrl}/customer/marqueebanner/fetchAllBanners`)
      .then((res) => {
        if (res.data.success === true) {
          const icons = ["🔥", "⚡", "🎯", "📢", "✨"];
          const formattedData = res.data.banners.map((item, index) => ({
            icon: icons[index % icons.length],
            text: item.title,
            link: item.link,
          }));
          setItems(formattedData);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchAllBanners();
  }, []);

  const allItems = [...items, ...items, ...items, ...items];

  return (
    <div
      className="marquee-banner"
      aria-label="Announcements"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 1100,
      }}
    >
      <div
        className="marquee-track"
        style={{
          animationDuration: `2s, ${speed}s`, // ✅ order: enter, scroll
        }}
      >
        {allItems.map((item, idx) => (
          <React.Fragment key={idx}>
            <span className="marquee-item">
              <span className="marquee-item__icon" aria-hidden="true">
                {item.icon}
              </span>
              <span className="marquee-item__text">{item.text}</span>
            </span>
            <span className="marquee-separator" aria-hidden="true" />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default MarqueeBanner;